import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import useStore from "../store/useStore";
import HeroComexButton from "../components/HeroComexButton";
import EventCard from "../components/EventCard";
import Seo from "../components/Seo";
import Switcher from "../components/switcher";

// Página de Eventos principal
export default function Eventos() {
  const {
    eventoHeroes,
    getEventoHeroes,
    eventos,
    fetchEventos,
    seoEventos,
    fetchSeoEventos,
  } = useStore();

  useEffect(() => {
    getEventoHeroes();
    fetchEventos();
    fetchSeoEventos();
  }, [getEventoHeroes, fetchEventos, fetchSeoEventos]);

  // Utilidad para obtener la mejor imagen disponible
  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  const getBestImageUrl = (imagen) => {
    if (!imagen) return "";
    if (imagen.url) return apiUrl + imagen.url;
    if (imagen.formats?.large?.url) return apiUrl + imagen.formats.large.url;
    if (imagen.formats?.medium?.url) return apiUrl + imagen.formats.medium.url;
    if (imagen.formats?.small?.url) return apiUrl + imagen.formats.small.url;
    if (imagen.formats?.thumbnail?.url)
      return apiUrl + imagen.formats.thumbnail.url;
    return "";
  };

  return (
    <>
      <Seo
        metaTitle={seoEventos[0]?.metatitle}
        metaDescription={seoEventos[0]?.metadescription}
        metaImage={seoEventos[0]?.metaimage?.url}
        metaKeywords={seoEventos[0]?.metakeywords}
        canonicalURL={seoEventos[0]?.canonicalurl}
      />
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue">
        {/* Sección principal de Eventos */}
        <section aria-label="Eventos y actividades de SIDOM">
          <section>
            {eventoHeroes && eventoHeroes.length > 0
              ? eventoHeroes.map((item, index) => (
                  <HeroComexButton
                    key={index}
                    video={item.video?.[0]?.url}
                    titulo={item.titulo}
                    texto={item.texto}
                    logo={item.img?.[0]?.url}
                    buttonText={item.boton_texto}
                    buttonLink={item.url}
                    height="h-[450px]"
                  />
                ))
              : null}
          </section>
          <section className="relative  flex flex-col justify-center items-center w-full">
            <div className="container  mb-[70px] md:mb-[100px] lg:mb-[90px] mt-[70px] md:mt-[100px] lg:mt-[90px]">
              <div className="relative flex flex-col justify-center ">
                <div className="container relative flex flex-col justify-center items-center ">
                  <div>
                    <div>
                      <h1 className="font-extrabold  text-left text-4xl md:text-5xl text-sidom-orange mb-[60px]">
                        Networking
                      </h1>
                    </div>
                    <div className="grid  xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-20 md:gap-5 lg:gap-6 w-full ">
                      {(eventos || []).map((item, index) => (
                        <EventCard
                          key={item.id || index}
                          slug={item.slug}
                          titulo={item.titulo}
                          estado={item.estado}
                          tipo={item.tipo_evento}
                          image={getBestImageUrl(item.imagen)}
                          data={item.fecha_y_hora || ""}
                          desc={
                            item.descripcion && item.descripcion[0]?.children
                              ? item.descripcion[0].children[0]?.text?.slice(
                                  0,
                                  120
                                ) + "..."
                              : ""
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </main>
      {/* Footer y switcher de tema */}
      <Footer />
      <Switcher />
    </>
  );
}
